import React, { Component } from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'
import { Draggable } from 'react-beautiful-dnd'

import DefaultSlideConfig from './DefaultSlideConfig'
import CrossBreakSlideConfig from './CrossBreakSlideConfig'
import DerivedSlideConfig from './DerivedSlideConfig'
import InheritedSlideConfig from './InheritedSlideConfig'
import ENUM from '../ENUM'
import QuestionAccordian from './QuestionAccordian'
import Button from '../../../UniformComponents/Button'
import MultiQuestionSlideConfig from './MultiQuestionSlideConfig'

@observer
class SlideConfig extends Component {
    minimiseClickHandler = () => {
        const { presentationStore, config } = this.props
        presentationStore.minimiseSlide(config.slide.id)
    }

    removeClickHandler = () => {
        const { removeSlideConfig, index } = this.props
        removeSlideConfig(index)
    }

    duplicateClickHandler = () => {
        const { config, presentationStore, index } = this.props
        presentationStore.duplicateSlide(config.slide, index)
    }

    componentDidMount = () => {
        const { globalYears, presentationStore, config } = this.props
        globalYears.forEach((item) => {
            if (item.checked) {
                const objectToUpdateWith = {
                    name: ENUM().comparisonSurveyIds,
                    value: item.value,
                    config,
                }
                presentationStore.updatePowerPointObj(objectToUpdateWith)
            }
        })
    }

    renderDeleteButton = () => {
        const {
            config: {
                question: { questionTypeCode },
            },
        } = this.props
        return (
            <div className="crossbreak-btns">
                {questionTypeCode === 'CrossBreak' ? (
                    <Button
                        label="Copy"
                        icon="fa-light fa-copy"
                        onClick={this.duplicateClickHandler}
                        cssClass="cross-break-copy-btn"
                    />
                ) : null}
                <Button
                    label="Delete"
                    icon="fa-regular fa-circle-xmark"
                    onClick={this.removeClickHandler}
                    cssClass="crossbreak-btns-delete"
                />

            </div>
        )
    }

    getTitle = () => {
        const { config, type } = this.props
        const { question } = config

        let title = ''

        if (type === 'CrossBreak') {
            title = i18n.t('powerpoint.title.crossBreak')
        } else if (type === 'Inherited') {
            title = i18n.t('powerpoint.title.inherited')
        } else if (type === 'Derived') {
            title = i18n.t('powerpoint.title.derived')
        } else if (type === 'LMX') {
            title = i18n.t('powerpoint.options.chart.matrix')
        } else if (type === 'MultiQuestion1x2') {
            title = '1x2 Chart'
        } else if (type === 'MultiQuestion1x3') {
            title = '1x3 Chart'
        } else if (type === 'MultiQuestion2x2') {
            title = '2x2 Chart'
        } else if (type === 'OSS') {
            title = ''
        } else {
            const shortTitle = question.content.getTitleByLocale('shortTitle', 'en_GB', 'en_GB')
            const longTitle = config.question.content.getTitleByLocale('longTitle', 'en_GB', 'en_GB')
            title = `${shortTitle} ${longTitle ? `- ${longTitle}` : ''}`
        }

        return title
    }

    render() {
        const {
            type,
            config,
            kpiOptions,
            derivedOptions,
            inheritedOptions,
            crossBreakSubQuestionOptions,
            globalYears,
            globalBenchmarks,
            presentationStore,
            index,
        } = this.props

        const show = presentationStore.openSlides.get(config.slide.id)
        const title = this.getTitle()

        const globalYearsOptions = globalYears
            .map((year) => ({
                name: ENUM().comparisonSurveyIds,
                value: year.value,
                label: year.label,
                checked: year.checked,
            }))
        let layout
        switch (type) {
            case 'CrossBreak':
                layout = (
                    <CrossBreakSlideConfig
                        type={type}
                        config={config}
                        kpiOptions={kpiOptions}
                        crossBreakSubQuestionOptions={cloneDeep(crossBreakSubQuestionOptions)}
                        globalYears={globalYearsOptions}
                        globalBenchmarks={config.benchmarks}
                        presentationStore={presentationStore}
                    />
                )
                break
            case 'Derived':
                layout = (
                    <DerivedSlideConfig
                        type={type}
                        config={config}
                        kpiOptions={kpiOptions}
                        derivedOptions={derivedOptions}
                        presentationStore={presentationStore}
                    />
                )
                break
            case 'Inherited':
                layout = (
                    <InheritedSlideConfig
                        config={config}
                        inheritedOptions={inheritedOptions}
                        globalYears={globalYearsOptions}
                        presentationStore={presentationStore}
                    />
                )
                break
            case 'MultiQuestion1x2':
            case 'MultiQuestion1x3':
            case 'MultiQuestion2x2':
                layout = (
                    <MultiQuestionSlideConfig
                        config={config}
                        globalYears={globalYearsOptions}
                        presentationStore={presentationStore}
                    />
                )
                break
            case 'LMX':
                layout = (
                    <DefaultSlideConfig
                        questionTypeCode={config.question.questionTypeCode}
                        config={config}
                        globalYears={globalYears}
                        globalBenchmarks={config.benchmarks}
                        presentationStore={presentationStore}
                    />
                )
                break
            case 'OSS':
                layout = (
                    <DefaultSlideConfig
                        questionTypeCode={config.question.questionTypeCode}
                        config={config}
                        globalYears={globalYears}
                        globalBenchmarks={config.benchmarks}
                        presentationStore={presentationStore}
                    />
                )
                break
            default:
                layout = (
                    <DefaultSlideConfig
                        questionTypeCode={config.question.questionTypeCode}
                        question={config.question}
                        config={config}
                        globalYears={globalYears}
                        globalBenchmarks={globalBenchmarks}
                        presentationStore={presentationStore}
                    />
                )
                break
        }
        return (
            <div>
                <div classNames="advanced-chart">
                    <Draggable
                        draggableId={`question_${config.slide.id}`}
                        id={`draggable_${config.slide.id}`}
                        index={index}
                        key={`draggable_${config.slide.id}`}
                    >
                        {(providedNxt) => (
                            <QuestionAccordian
                                appStore={presentationStore.store}
                                presentationStore={presentationStore}
                                question={config.question}
                                config={config}
                                provided={providedNxt}
                                show={show}
                                toggle={this.minimiseClickHandler}
                                content={layout}
                                preview
                                isFullSize
                                options={this.renderDeleteButton}
                                type={type}
                                titleContent={`${title} (${type}) ${(config.question.metadata.kpiType) ? ` KPI type: ${config.question.metadata.kpiType}` : ''}`}
                                oid={R.pathOr(1, ['question', 'metadata', 'oid'], config)}
                            />
                        )}

                    </Draggable>
                </div>
            </div>
        )
    }
}

export default SlideConfig
